export default "__VITE_ASSET__BeI5KrNo__"